import { Link, useNavigate } from "react-router-dom";
import { Button, Dialog, H2, Intent } from "@blueprintjs/core";
import { IUser } from "controllers/users/action";
import "./NeedVerify.scss";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchUserPoll } from "controllers/user/action";
import { Analytics } from "utils/analytics";

interface NeedVerifyProps {
  user: IUser;
}

export default function NeedVerify(props: NeedVerifyProps) {
  const { user } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleRedirect = () => navigate("/");

  useEffect(() => {
    Analytics.getInstance().event("Need Verify", "Opened");
    return () => { };
  }, []);

  useEffect(() => {
    dispatch(fetchUserPoll(5000));
    return () => {
      dispatch(fetchUserPoll(undefined));
    };
  }, [dispatch]);

  return (
    <Dialog className="need-verify" isOpen>
      <div className="form__header">
        <H2>Verify Your Email</H2>
        <Button minimal intent={Intent.PRIMARY} icon="cross" onClick={handleRedirect} />
      </div>
      <form>
        <p>
          Your email address <strong>{user.email}</strong> has not been verified.
        </p>
        <p>
          To complete the verification process, please check your inbox for an email titled "ESET Account Email Verification" and follow the instructions provided in the email.
        </p>
        <p>
          If you can't find the email or if the verification link has expired, don't worry. You can easily resend the verification email or update your email address by visiting the <Link to="/dashboard/account_settings">Account Settings</Link> page.
        </p>
        <p>
          Thank you for your cooperation!
        </p>
        <div className="form__footer">
          <Button
            className="button-submit"
            icon="arrow-left"
            intent="primary"
            key="goHome"
            text="Go Back Home"
            onClick={handleRedirect}
          />
        </div>
      </form>
    </Dialog >
  );
}
